<template>
  <div style="margin-top: 5px" id="target" class="e-card">
    <div class="e-card-title">{{ gridTitle }}</div>
    <div class="e-card-separator"></div>
    <div class="e-card-content">
      <ejs-grid
        ref="grid"
        :dataSource="dataSource"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :created="created"
        :queryCellInfo="customiseCell"
        :commandClick="commandClick"
        :allowTextWrap="true"
        :allowResizing="true"
      >
        <e-columns v-if="visibleColumns && visibleColumns.length > 0">
          <e-column
            v-if="visibleColumns.includes('Commands')"
            headerText="Application"
            :commands="commands"
            textAlign="Left"
            width="130"  />

          <e-column
            v-if="visibleColumns.includes('recNo')"
            field="recNo"
            headerText="Order ID"
            textAlign="Left"
            width="120" />

          <e-column
            v-if="visibleColumns.includes('requestor')"
            field="requestor"
            headerText="Requestor"
            textAlign="Left"
            width="180"
            />

          <e-column
            v-if="visibleColumns.includes('productName')"
            field="productName"
            headerText="Application Type"
            textAlign="Left"
          />
          <e-column
            v-if="visibleColumns.includes('permitNo')"
            field="permitNo"
            headerText="Permit #"
            textAlign="Left"
            width="150"
          />
          <e-column
            v-if="visibleColumns.includes('requestDate')"
            field="requestDate"
            headerText="Application Date"
            type="date"
            format="MMM dd, yyyy"
            textAlign="Left"
            width="150"
          />
          <e-column
            v-if="visibleColumns.includes('invoiceNumber')"
            field="invoiceNumber"
            headerText="Invoice #"
            textAlign="Left"
            width="130"
          />
          <e-column
            v-if="visibleColumns.includes('status')"
            field="status" headerText="Status" textAlign="Left" />
          <e-column
            v-if="visibleColumns.includes('externalNotes')"
            field="externalNotes"
            headerText="Notes"
            :disableHtmlEncode="false"
            textAlign="Left"
          />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from '@syncfusion/ej2-vue-grids';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { mapActions, mapGetters } from 'vuex';
import { tokenStorage } from '@/shared/storage-service';
import { deleteApplication, getPDF } from '../services/applications-api';
import { GET_APPLICATIONWORKLISTS, SET_PERMIT } from '../../permitting/store';
import { SET_SELECTED_OWNER } from '../../sites/store';
import { SET_SELECTED_USER } from "../../reports/store";

Vue.use(GridPlugin);
let DialogObj;

export default {
  name: 'ApplicationChildForm',
  props: {
    gridTitle: String,
    dataSource: Array,
    visibleColumns: Array,
  },
  data() {
    return {
      commands: [
        {
          type: 'GoTo',
          buttonOption: {
            cssClass: 'e-flat gotobtn',
            iconCss: 'e-open-link e-icons',
          },
        },
        {
          type: 'Delete',
          buttonOption: {
            cssClass: 'e-flat deletebtn',
            iconCss: 'e-delete e-icons',
          },
        },
        {
          type: 'View PDF',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      toolbarOptions: ['Search'],
      pageSettings: { pageSize: 10 },
      requestToDelete: null,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
  },
  methods: {
    ...mapActions({
      fetchPermit: SET_PERMIT,
      fetchApplicationWorkList: GET_APPLICATIONWORKLISTS,
    }),
    created() {
      // Added clear button and its functionalities to Searchbar
      document
        .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
        .addEventListener('keyup', (e) => {
          const searchBtnEle = document.getElementById(`${this.$refs.grid.$el.id}_searchbutton`);
          const clearBtnEle = searchBtnEle.cloneNode(true);
          clearBtnEle.id = `${this.$refs.grid.$el.id}_clearbutton`;
          clearBtnEle.classList.remove('e-search-icon');
          clearBtnEle.classList.add('e-clear-icon');

          clearBtnEle.addEventListener('click', () => {
            e.target.value = '';
            document.getElementById(`${this.$refs.grid.$el.id}_clearbutton`).remove();
          });

          if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
            searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
          } else if (!e.target.value || e.target.value === '') {
            document.getElementById(`${this.$refs.grid.$el.id}_clearbutton`).remove();
          }
        });
    },
    async commandClick(args) {
      const request = args.rowData;
      // eslint-disable-next-line default-case
      switch (args.commandColumn.type) {
        case 'GoTo':
          // eslint-disable-next-line no-case-declarations
          const { rowData } = args;
          // eslint-disable-next-line no-case-declarations
          const { requestType } = rowData;
          // eslint-disable-next-line no-case-declarations
          const { ePermitId } = rowData;
          if (rowData.requestType === 'STSOP' || rowData.requestType === 'STSOPPATCH') {
            // -- set up store of owner
            const selectedOwner = {
              eServicesUserStatus: request.eServicesUserStatus,
              firstEmail: request.requestUserEmail,
              emailAddress: request.requestUserEmail,
              ownerContactID: request.ownerContactId,
              ownerID: request.ownerId,
              requestId: request.requestId,
              ownerFullInfo: `${request.ownerId}, ${request.requestor}(${request.ownerContactId}), ${request.requestUserEmail}, (${request.eServicesUserStatus})`,
            };
            this.$store.commit(SET_SELECTED_OWNER, selectedOwner);
            this.$router.push({ name: 'Sites' });
          } else if (rowData.requestType === 'Miscellaneous' || rowData.requestType === 'Additional Invoice') {
            this.$router.push(`/reports/transactions`);
            await this.$store.commit(SET_SELECTED_USER, {
              selectedUser: {
                email: request.requestUserEmail,
                ownerContactId: request.ownerContactId,
                ownerId: request.ownerId,
                userFullName: request.requestor,
                userId: request.requestUserId,
              },
            });
          } else if (ePermitId) {
            await this.fetchPermit({ ePermitId });
            await this.fetchApplicationWorkList(ePermitId);
            this.$router.push({
              name: 'PermitApplication',
              query: { permitType: requestType, ePermitId },
            });
          } else {
            this.$router.push(`/search/tank/${request.requestId}`);
          }
          break;
        case 'Delete':
          this.requestToDelete = request;
          DialogObj = DialogUtility.confirm({
            title: 'Delete Application',
            content: 'Are you sure you want to delete application?',
            okButton: { text: 'OK', click: this.deleteRequest },
            cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' },
          });
          break;
        case 'View PDF':
          // eslint-disable-next-line no-case-declarations
          const accessToken = tokenStorage.getAccessToken();
          // eslint-disable-next-line no-case-declarations
          const userId = this.loggedUser.id;
          // eslint-disable-next-line no-case-declarations
          const { requestId } = request;
          await getPDF(userId, accessToken, requestId).then((res) => {
            window.location.href = `${res.config.baseURL}${res.config.url}`;
          });
          break;
      }
    },
    async deleteRequest() {
      const data = this.requestToDelete;
      data.deleteFlag = true;
      await deleteApplication(data)
        .then(() => {
          const index = this.dataSource.findIndex((x) => x.requestId === data.requestId);
          if (index >= 0) this.dataSource.splice(index, 1);
          this.$refs.grid.refresh();
          this.hideDeleteDialog();
        })
        .catch((error) => {
          console.error(`postapplication_err:${error.Status}`);
          this.hideDeleteDialog();
          DialogUtility.alert(error.message);
        });
    },
    hideDeleteDialog() {
      DialogObj.hide();
    },
    customiseCell(args) {
      if (args.column.commands) {
        if (args.data.status.trim().toLowerCase() === 'in progress') {
          args.cell.querySelector('.viewpdfbtn').classList.add('hidebtn');
          if (args.data.requestType === 'STSOP' || args.data.requestType === 'STSOPPATCH') {
            args.cell.querySelector('.deletebtn').classList.add('hidebtn');
          }
          if (args.data.requestType === 'STSOPTEMP') {
            args.cell.querySelector('.gotobtn').classList.add('hidebtn');
          }
        } else if (args.data.requestType === 'Miscellaneous' || args.data.requestType === 'Additional Invoice') {
          args.cell.querySelector('.viewpdfbtn').classList.add('hidebtn');
          args.cell.querySelector('.deletebtn').classList.add('hidebtn');
        } else {
          if (args.data.requestType !== 'STSOP' && args.data.requestType !== 'STSOPPATCH') {
            args.cell.querySelector('.gotobtn').classList.add('hidebtn');
          }
          args.cell.querySelector('.deletebtn').classList.add('hidebtn');
        }
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
.e-open-link:before {
  content: "\e34a";
}
.e-dialog .e-dlg-header-content {
  background: #0f4b90;
  padding: 12px;
  margin-bottom: 20px;
}
.e-dlg-header,
.e-dlg-header * {
  color: white;
  width: auto !important;
}
.wrap {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 20px 10px;
  width: 340px;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
.hidebtn {
  display: none;
}
.e-card-title {
  background: #0f4b90;
  color: white;
}
</style>
